<template>
  <div>
    <b-carousel
      ref="mediaCarousel"
      v-model="slide"
      :interval="4000"
      no-animation
      controls
      background="#ababab"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide class="image-slide" v-for="(image, idx) in imageList" :key="`image-${idx}`">
        <template v-slot:img>
          <b-img
            fluid
            v-bind="mainProps"
            :src="image.url"
            :alt="image.title"
            style="object-fit: cover;"></b-img>
        </template>
        <p class="image-caption-text">{{image.excerpt ? image.excerpt : 'No description.'}}</p>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
/**
 * Media carousel component.
 *
 * This component contains all the interactions
 * for lightbox carousel for area media.
 */
export default {
  props: ['selectedImage', 'imageList'],
  data() {
    return {
      slide: 0,
      sliding: null,
      mainProps: { width: 1920, height: 1080 },
    };
  },
  mounted() {
    /** Set the first image to show in carousel */
    this.$refs.mediaCarousel.setSlide(this.selectedImage);
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
};
</script>

<style>
.image-slide > .carousel-caption {
  bottom: 0;
  padding: 0;
}

.image-caption-text {
  color: #ffffff;
  background: rgba(0, 0, 0, 0.7);
  padding: 1.2rem;
}
</style>
